import {useLocation} from "react-router-dom";

export function useQuery() {
	// devLog(useLocation().search.split('?').slice(1).map(query=> query.split('=')))
	return new URLSearchParams(useLocation().search);
}
